const ACCOUNT_ACTIVITY_KEY = 'accountActivity';
const ACCOUNT_OWNER_METADATA_KEY = 'accountOwnerMetadata';
const AUTO_GEN_REVIEWS_KEY = 'autoGenReviews';
const BANK_DOCUMENTS_KEY = 'bankDocuments';
const BANK_DISPENSARY_KEY = 'bankDispensary';
const BANK_KEY = 'bank';
const BANK_NICKNAME_KEY = 'bankNickname';
const BANK_QUESTIONNAIRES_KEY = 'bankQuestionnaires';
const BANK_TEMPLATES_KEY = 'templates';
const BUSINESS_VERIFICATION_KEY = 'businessVerification';
const DISPENSARY_ASSOCIATE_PARENT_KEY = 'dispensaryAssociateParent';
const DISPENSARY_LAST_INGESTION_KEY = 'dispensaryLastIngestion';
const DISPENSARY_METADATA_KEY = 'dispensaryMetadata';
const DISPENSARY_PARENT_FOR_LOCATION_KEY = 'dispensaryParentForLocation';
const DISPENSARY_STAFF_KEY = 'dispensaryStaff';
const DISPENSARY_UPCOMING_REPORTS_KEY = 'dispensaryUpcomingReports';
const DISPENSARY_USERS_KEY = 'dispensaryUsers';
const DOCUMENTS_KEY = 'documents';
const FI_MARKETPLACE_OFFERS_KEY = 'fiMarketplaceOffers';
const GCD_USER_KEY = 'gcdUser';
const INGESTION_DATA_KEY = 'ingestionData';
const INTERNAL_DOCUMENTS_KEY = 'internalDocuments';
const INVITED_DISPENSARIES_KEY = 'invitedDispensaries';
const LICENSES_KEY = 'licenses';
const LOCATION_DISPENSARY_KEY = 'locationDispensary';
const MAX_DEPOSIT_KEY = 'maxDeposit';
const METADATA_KEY = 'metadata';
const MINIFIED_DISPENSARIES_KEY = 'minifiedDispensaries';
const MUOS_KEY = 'muos';
const NEGATIVE_NEWS_KEY = 'negativeNews';
const PAYQWICK_USER_KEY = 'payqwickUser';
const QUESTIONNAIRE_BULK_ASSIGN_KEY = 'questionnaireBulkAssign';
const QUESTIONNAIRE_BULK_UNASSIGN_KEY = 'questionnaireBulkUnassign';
const QUESTIONNAIRE_OVERVIEW_KEY = 'questionnaireOverview';
const QUESTIONNAIRE_TEMPLATES_KEY = 'questionnaireTemplates';
const QUESTIONNAIRE_TO_CRB_KEY = 'questionnaireToCrb';
const RISK_NARRATIVE_JOURNEYS_KEY = 'riskNarrativeJourneys';
const RISK_NARRATIVE_STRATEGY_KEY = 'riskNarrativeStrategy';
const ROOT_DOCUMENTS_KEY = 'rootDocuments';
const BANK_STAFF_KEY = 'bankStaff';
const TEMPLATE_KEY = 'template';
const TEMPLATE_RESULT_KEY = 'templateResult';
const TEMPLATES_KEY = 'templates';
const TRANSACTION_CODES_KEY = 'transactionCodes';
const USER_DETAILS_KEY = 'userDetails';
const USER_KEY = 'user';
const INVITE_USER_KEY = 'inviteUser';
const ONBOARDING_DOC_REQ_DOCUMENT_STATUS_KEY = 'onboardingDocReqDocumentStatus';
const GC_MANAGED_TEMPLATE_METADATAS_KEY = 'gcManagedTemplateMetadatas';
const CRB_MARKETPLACE_OFFERS_KEY = 'crbMarketplaceOffers';
const DISPENSARY_BANKS_KEY = 'dispensaryBanks';

export {
  ACCOUNT_ACTIVITY_KEY,
  ACCOUNT_OWNER_METADATA_KEY,
  AUTO_GEN_REVIEWS_KEY,
  BANK_DISPENSARY_KEY,
  BANK_DOCUMENTS_KEY,
  BANK_KEY,
  BANK_NICKNAME_KEY,
  BANK_QUESTIONNAIRES_KEY,
  BANK_STAFF_KEY,
  BANK_TEMPLATES_KEY,
  BUSINESS_VERIFICATION_KEY,
  CRB_MARKETPLACE_OFFERS_KEY,
  DISPENSARY_ASSOCIATE_PARENT_KEY,
  DISPENSARY_BANKS_KEY,
  DISPENSARY_LAST_INGESTION_KEY,
  DISPENSARY_METADATA_KEY,
  DISPENSARY_PARENT_FOR_LOCATION_KEY,
  DISPENSARY_STAFF_KEY,
  DISPENSARY_UPCOMING_REPORTS_KEY,
  DISPENSARY_USERS_KEY,
  DOCUMENTS_KEY,
  FI_MARKETPLACE_OFFERS_KEY,
  GC_MANAGED_TEMPLATE_METADATAS_KEY,
  GCD_USER_KEY,
  INGESTION_DATA_KEY,
  INTERNAL_DOCUMENTS_KEY,
  INVITE_USER_KEY,
  INVITED_DISPENSARIES_KEY,
  LICENSES_KEY,
  LOCATION_DISPENSARY_KEY,
  MAX_DEPOSIT_KEY,
  METADATA_KEY,
  MINIFIED_DISPENSARIES_KEY,
  MUOS_KEY,
  NEGATIVE_NEWS_KEY,
  ONBOARDING_DOC_REQ_DOCUMENT_STATUS_KEY,
  PAYQWICK_USER_KEY,
  QUESTIONNAIRE_BULK_ASSIGN_KEY,
  QUESTIONNAIRE_BULK_UNASSIGN_KEY,
  QUESTIONNAIRE_OVERVIEW_KEY,
  QUESTIONNAIRE_TEMPLATES_KEY,
  QUESTIONNAIRE_TO_CRB_KEY,
  RISK_NARRATIVE_JOURNEYS_KEY,
  RISK_NARRATIVE_STRATEGY_KEY,
  ROOT_DOCUMENTS_KEY,
  TEMPLATE_KEY,
  TEMPLATE_RESULT_KEY,
  TEMPLATES_KEY,
  TRANSACTION_CODES_KEY,
  USER_DETAILS_KEY,
  USER_KEY
};
